module.exports = __webpack_public_path__ + "static/media/activity_details_location.d9ad8ebb.svg";